import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})

export class ApplicantService {
  http: HttpClient;

  constructor(http: HttpClient) {
    this.http = http;
  }

  getPersonalInfo() {
    var url = "/Applicant/GetPersonalInfo";
    return this.http.get(url).toPromise();
  }

  getStagesByProfileID() {
    var url = "/Applicant/GetStagesByProfileID";
    return this.http.get(url).toPromise();
  }

  getReqColumns(reqForm: string) {
    var url = "/Applicant/GetReqColumns?reqForm=" + reqForm;
    return this.http.get(url).toPromise();
  }

  getRecruiterList() {
    var url = "/Applicant/GetRecruiterList";
    return this.http.get(url).toPromise();
  }

  getApplicantsByJobReq(requestParam: string) {
    var url = "/Applicant/GetApplicantsByJobReq?" + requestParam;
    return this.http.get(url).toPromise();
  }

  exportJobReqFull(reqStageID: string, status: string, startDate: string, endDate: string, searchString: string, district: string, filename: string) {
    var url = "/Applicant/ExportJobReqFull?reqStageID=" + reqStageID + "&status=" + status +
    "&startDate=" + startDate + "&endDate=" + endDate + "&searchString=" + searchString + "&district=" + district + "&filename=" + filename;
    return this.http.get(url).toPromise();
  }

  getApplicantSearchReportFull(requestObj: any) {
    var url = "/Applicant/getApplicantSearchReportFull?file=" + requestObj.file + "&beginDate=" + requestObj.beginDate +
      "&endDate=" + requestObj.endDate + "&filename=" + requestObj.filename + "&district=" + requestObj.district + "&appStage=" +
      requestObj.appStage + "&reqID=" + requestObj.reqID;
      return this.http.get(url).toPromise();
  }

  getStages(reqID?: any, onboardID?: any){
    var url = "/Applicant/GetStages?reqID=" + reqID + "&onboardID=" + onboardID
    return this.http.get(url).toPromise();
  }
  
  getReqDetails(reqID?:any, reqApplyToken?:any) {
    var url = "/Applicant/GetReqDetails?reqID=" + reqID + "&reqApplyToken=" + reqApplyToken;
    return this.http.get(url).toPromise();
  }

  reqSpecQuesAnswerGet(reqID?: any, onboardID?: any) {
    var url = "/Applicant/ReqSpecQuesAnswerGet?reqID=" + reqID + "&onboardID=" + onboardID;
    return this.http.get(url).toPromise();
  }

  getPersonalInfoForDate(onboardID: string){
    var url = "/Applicant/GetPersonalInfoForDate?onboardID=" + onboardID
    return this.http.get(url).toPromise();
  }
  
  updateDispReason(onboardID: string, dispReason: string) {
    return this.http.post("/Applicant/UpdateDispReason", {
      onboardID: onboardID,
      dispReason: dispReason
    }).toPromise();
  }
  
  personalInfoEdit(data: any) {
    return this.http.post("/Applicant/PersonalInfoEdit", {
      onboardID: data.onboardID,
      firstName: data.firstName,
      lastName: data.lastName,
      email: data.email,
      phone: data.phone,
      address1: data.address1,
      address2: data.address2,
      city: data.city,
      state: data.state,
      cell: data.cell,
      zip: data.zip,
      contact: data.contact,
      contactSource: data.contactSource,
      contactSourceNotes: data.contactSourceNotes,
      hireDateStr: data.hireDateStr,
      country: data.country,
      midName: data.midName,
      suffix: data.suffix,
      hRRMKeyID: data.hRRMKeyID,
      birthdayStr: data.birthdayStr, 
      maritalStatus: data.maritalStatus,
      countryOther: data.countryOther,
      isManagerEdit: data.isManagerEdit,
      reservedHRRef: data.reservedHRRef
    }).toPromise();
  }

  applicantHistoryGet(reqApplicantID?: any, reqID?: any) {
    var url = "/Applicant/ApplicantHistoryGet?reqApplicantID=" + reqApplicantID + "&reqID=" + reqID;
    return this.http.get(url).toPromise();
  }

  getApplicantPrevReqs(onboardID?: any) {
    var url = "/Applicant/GetApplicantPrevReqs?onboardID=" + onboardID;
    return this.http.get(url).toPromise();
  }

  applicantChangeStage(reqApplicantIDString: string, reqStageID?: number) {
    return this.http.post("/Applicant/ApplicantChangeStage", {
      reqApplicantIDString: reqApplicantIDString,
      reqStageID: reqStageID
    }).toPromise();
  }

  setDateHired(onboardID: string, hireDateStr: string) {
    return this.http.post("/Applicant/SetDateHired", {
      onboardID: onboardID,
      hireDateStr: hireDateStr
    }).toPromise();
  }
  getAssignedRecruiters(reqID?: any){
    var url = "/Applicant/GetAssignedRecruiters?reqID=" + reqID
    return this.http.get(url).toPromise();
  }
  
  getReqGrid(status: string){
    var url = "/Applicant/GetReqGrid?status=" + status;
    return this.http.get(url).toPromise();
  }
  
  reqCopyMove(onboardID?: any, isCopy?: boolean, moveToReqID?: any, onboardIDArray?: any[]) {
    return this.http.post("/Applicant/ReqCopyMove", {
      onboardID: onboardID,
      isCopy: isCopy,
      moveToReqID: moveToReqID,
      onboardIDArray: onboardIDArray
    }).toPromise();
  }
  
  applicantRatingGet(reqApplicantID?: any){
    var url = "/Applicant/ApplicantRatingGet?reqApplicantID=" + reqApplicantID;
    return this.http.get(url).toPromise();
  }
  
  applicantRatingAddEdit(reqApplicantID?: any, ratingValue?: string, reqID?: any, reqApplicantRatingID?: any, ratingStage?: string) {
    return this.http.post("/Applicant/ApplicantRatingAddEdit", {
      reqApplicantID: reqApplicantID,
      ratingValue: ratingValue,
      reqID: reqID,
      reqApplicantRatingID: reqApplicantRatingID,
      ratingStage: ratingStage
    }).toPromise();
  }

  applicantRatingRemove(reqApplicantID?: any, reqApplicantRatingID?: number) {
    return this.http.post("/Applicant/ApplicantRatingRemove", {
      reqApplicantID: reqApplicantID,
      reqApplicantRatingID: reqApplicantRatingID
    }).toPromise();
  }

  setVeteranReview(onboardID?: any, isRecommended?: boolean) {
    return this.http.post("/Applicant/SetVeteranReview", {
      onboardID: onboardID,
      isRecommended: isRecommended
    }).toPromise();
  }

  applicantToOnboard(onboardID?: any, onboardProfileID?: number, reqID?: any) {
    return this.http.post("/Applicant/ApplicantToOnboard", {
      onboardID: onboardID,
      onboardProfileID: onboardProfileID,
      reqID: reqID
    }).toPromise();
  }

  deleteApplicant(onboardID?: any) {
    return this.http.post("/Applicant/DeleteApplicant", {
      onboardID: onboardID
    }).toPromise();
  }

  sendBulkEmail(requestObj?: any) {
    return this.http.post("/Applicant/SendBulkEmail", {
      toEmail: requestObj.toEmail,
      ccEmail: requestObj.ccEmail,
      bccEmail: requestObj.bccEmail,
      subject: requestObj.subject,
      body: requestObj.body,
      newFilenames: requestObj.newFilenames,
      newFiles: requestObj.newFiles,
      onboardID: requestObj.onboardID,
      reqID: requestObj.reqID,
      emailTemplateID: requestObj.emailTemplateID,
      includeICS: requestObj.includeICS,
      icsStartDate: requestObj.icsStartDate,
      icsEndDate: requestObj.icsEndDate,
      location: requestObj.location,
      sendEmail: requestObj.sendEmail,
      templateTo: requestObj.templateTo,
      mailFrom: requestObj.mailFrom,
      queueType: requestObj.queueType,
      notificationMode: requestObj.notificationMode,
      sMSTo: requestObj.sMSTo
    }).toPromise();
  }

  sendEmail(requestObj?: any) {
    return this.http.post("/Applicant/SendEmail", {
      toEmail: requestObj.toEmail,
      ccEmail: requestObj.ccEmail,
      bccEmail: requestObj.bccEmail,
      subject: requestObj.subject,
      body: requestObj.body,
      newFilenames: requestObj.newFilenames,
      newFiles: requestObj.newFiles,
      includeICS: requestObj.includeICS,
      icsStartDate: requestObj.icsStartDate,
      icsEndDate: requestObj.icsEndDate,
      location: requestObj.location,
      onboardID: requestObj.onboardID,
      reqID: requestObj.reqID,
      mailFrom: requestObj.mailFrom,
      queueType: requestObj.queueType,
      notificationMode: requestObj.notificationMode,
      sMSTo: requestObj.sMSTo
    }).toPromise();
  }

}
